export const equipmentAncillary = [
  {
    name: 'equipment_ancillary_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
